var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 92.8349C21.9451 92.8349 1.55967 72.4493 1.55967 47.3946C1.55967 22.3397 21.9451 1.9542 47 1.9542C72.055 1.9542 92.4404 22.3397 92.4404 47.3946C92.4404 72.4493 72.055 92.8349 47 92.8349Z",
    fill: "#F6F6F6",
    stroke: "#DCDCDC",
    strokeWidth: 2.33028
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.434 66.7402H37.5669C35.8302 66.7402 34.4224 65.3323 34.4224 63.5957V63.5957C34.4224 61.859 35.8302 60.4512 37.5669 60.4512H56.434C58.1706 60.4512 59.5785 61.859 59.5785 63.5957V63.5957C59.5785 65.3323 58.1706 66.7402 56.434 66.7402Z",
    fill: "#DCDCDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7917 39.8461C37.9177 39.8461 40.4519 37.312 40.4519 34.186C40.4519 31.06 37.9177 28.5259 34.7917 28.5259C31.6657 28.5259 29.1316 31.06 29.1316 34.186C29.1316 37.312 31.6657 39.8461 34.7917 39.8461Z",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.209 39.8461C62.335 39.8461 64.8691 37.312 64.8691 34.186C64.8691 31.06 62.335 28.5259 59.209 28.5259C56.083 28.5259 53.5488 31.06 53.5488 34.186C53.5488 37.312 56.083 39.8461 59.209 39.8461Z",
    fill: "#DCDCDC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyListIcon);
export default __webpack_public_path__ + "static/media/emptyListIcon.2292eced4181877c13687f16e78f5627.svg";
export { ForwardRef as ReactComponent };